"use strict";
var lightbox_service_1 = require("./lightbox.service");
exports.Lightbox = lightbox_service_1.Lightbox;
var lightbox_config_service_1 = require("./lightbox-config.service");
exports.LightboxConfig = lightbox_config_service_1.LightboxConfig;
var lightbox_event_service_1 = require("./lightbox-event.service");
exports.LightboxEvent = lightbox_event_service_1.LightboxEvent;
exports.LIGHTBOX_EVENT = lightbox_event_service_1.LIGHTBOX_EVENT;
var lightbox_module_1 = require("./lightbox.module");
exports.LightboxModule = lightbox_module_1.LightboxModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-lightbox/index.js
// module id = 54
// module chunks = 0